import { generateApiPath } from "@routes/generatePath.ts";
import type { IExtractApiParams } from "@routes/types.ts";

const pathBase = `/hospitalizes/`;
const pathById = `${pathBase}:hospitalizationId/`;

type IPathByIdParams = IExtractApiParams<typeof pathById>;

export const hospitalization = {
  getAll: () => generateApiPath(pathBase),
  post: () => generateApiPath(pathBase),
  put: (params: IPathByIdParams) => generateApiPath(pathById, params),
  delete: (params: IPathByIdParams) => generateApiPath(pathById, params),
};
